<template>
  <div class="rightpage" :style="step == 1 ? 'margin-top: 3.8rem;' : ''" 
       v-if="odkey!='' && summary>0">
    <bookingTripSummary :step="step" :rmkey="rmkey" :odkey="odkey"></bookingTripSummary>
    <bookingPriceSummary ref="bookingPriceSummaryRef" :step="step" :refidx="refidx" :rmkey="rmkey" :odkey="odkey"
       @oTotalRef="oTotalRef" @offerPriceUpdate = "offerPriceUpdate" @summaryPriceUpdate="summaryPriceUpdate"></bookingPriceSummary>
    <bookingTravelerSummary :refidx="refidx" :rmkey="rmkey" :odkey="odkey"
     :step="step" :roomlist="roomlist" v-if="step > 1"></bookingTravelerSummary>
    <bookingFlightSummary v-if="odata && odata.isFlight>0" :step="step" :rmkey="rmkey" :odkey="odkey"
      :offerSelected="offerSelected" :respond_id="respond_id" :refidx="refidx+idx"
      :flyOffer="flyOffer"></bookingFlightSummary>
    <InsuranceSummary style="margin-bottom: 2.4rem;"/>
    <bookingPaymentSummary :step="step" :refidx="refidx+idx" :rmkey="rmkey" :odkey="odkey"
      :priceSummary="priceSummary" :offerSelected="offerSelected" :agentComm="agentComm"
      :flyOffer="flyOffer" :selectedPaymentType="selectedPaymentType" :chargeAmount="chargeAmount"></bookingPaymentSummary>
  </div>
</template>
<script>
import bookingTripSummary from "./bookingTripSummary.vue";
import bookingPriceSummary from "./bookingPriceSummary.vue";
import bookingFlightSummary from "./bookingFlightSummary.vue";
import bookingTravelerSummary from "./bookingTravelerSummary.vue";
import bookingPaymentSummary from "./bookingPaymentSummary.vue";
import InsuranceSummary from "./insurance/InsuranceSummary.vue";
import { notEmpty } from '@/utils/tool.js'
import { localDriver } from '@/utils/localDriver'

export default {
  emits:['offerPriceUpdate'],
  props: ['step', 'offerSelected', 'respond_id', 'refidx', 'flyOffer','odkey','rmkey','agentComm','selectedPaymentType','chargeAmount'],
  components: {
    bookingTripSummary: bookingTripSummary,
    bookingPriceSummary: bookingPriceSummary,
    bookingTravelerSummary: bookingTravelerSummary,
    bookingFlightSummary: bookingFlightSummary,
    bookingPaymentSummary: bookingPaymentSummary,
    InsuranceSummary: InsuranceSummary
  },
  data() {
    return {
      notEmpty,
      pressnum: 2,
      ismobile: false,
      priceSummary: {},
      roomlist: {},
      odata:{},
      summary:0,
      roomlistSyncTimer: null,
      idx:1,
    };
  },
  watch: {
    step: {
      handler(newValue, oldValue) {
        //console.log('------------booking Summary watch here-----',newValue);
      },
      deep: true
    },
    refidx: {
      async handler(newValue, oldValue) {
        this.scheduleRoomlistSync()
      },
      deep: true
    },
  },
  async mounted() {
    this.ismobile = (document.documentElement.clientWidth < 750)
    this.odata = await localDriver.getItem(this.odkey) 
    this.roomlist = await localDriver.getItem(this.rmkey)
    if((this.odata?.product_id??0)<1) {
      window.location.href = '/'
    } else if (!notEmpty(this.roomlist)) {
      window.location.href = '/details?id=' + this.odata.product_id
    }
    else{
      this.summary =1;
    }
  },
  methods: {
    summaryPriceUpdate(){
      this.idx++
    },
    scheduleRoomlistSync(delay = 30) {
      if (this.roomlistSyncTimer) {
        clearTimeout(this.roomlistSyncTimer)
      }
      this.roomlistSyncTimer = setTimeout(async () => {
        this.roomlist = await localDriver.getItem(this.rmkey)
      }, delay)
    },
    oTotalRef(param) {
      this.priceSummary = param.priceSummary;
    },
    offerPriceUpdate(parms) {
      this.$emit('offerPriceUpdate',parms);
    },
    // Delegates to bookingPriceSummary's on-demand check so a page (e.g. payment.vue)
    // can force one right before submitting, instead of waiting on the periodic timer.
    async forcePriceCheck() {
      return (await this.$refs.bookingPriceSummaryRef?.forcePriceCheck()) ?? true
    },
  }
};
</script>

<!-- 公共区域 -->
<style scoped>
.rightpage {
  width: 29%;
}

/* 移动端  */
@media screen and (max-width:750px) {
  .rightpage {
    width: 100%;
    margin-top: 0;
  }
}
</style>
